import React from 'react';
import './Spinner.css';

const SpinnerExt = ({ show, message = "Espere un momento...", onRecargar, onRevisar }) => {    

    const handleRevisarClick = () => {
        if (onRevisar) {
            onRevisar();  // Llamamos a la funci�n pasada como prop
        }
    }

    const handleRecargarClick = () => {
        if (onRecargar) {
            onRecargar();  // Llamamos a la funci�n pasada como prop
        }
    }

    if (show) {
        removeNone();
        return (
            <div>
                <div className="subloader active">
                    <span className="relative"></span>
                    <p>{message}</p>

                    <div className="btns">
                        <button onClick={handleRecargarClick} className="btn primary">
                            <i className="fa fa-undo"></i> Continuar
                        </button>

                        <button onClick={handleRevisarClick} className="btn primary">
                            <i className="fa fa-read"></i> Revisar respuesta
                        </button>

                    </div>
                    
                </div>
                <div>
                    
                </div>
            </div>
            
        )
    }
    else
        return null;
        //return (
        //    //<div className="subloader">
        //    //    <div className="relative"></div>
        //    //</div>

        //)
}


function removeNone() {
    setTimeout(() => {
        if (document.querySelector(".reloadLate"))
            document.querySelector(".reloadLate").classList.remove('none')
    }, 10000);
}

export default SpinnerExt;


